<template>
  <div class="flex items-center justify-center h-full">
    <span
      class="px-2 py-0.5 rounded text-xs font-bold"
      :class="priorityClass"
    >
      {{ priorityLabel }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'Quality_PriorityCell',
  props: ['params'],
  computed: {
    priority() {
      return this.params.data?.priority || 'normal';
    },
    priorityClass() {
      const classes = {
        'critical': 'bg-red-600 text-white',
        'high': 'bg-primary-500 text-white',
        'medium': 'bg-yellow-100 text-yellow-800',
        'normal': 'bg-gray-100 text-gray-600',
        'low': 'bg-gray-50 text-gray-400'
      };
      return classes[this.priority] || classes.normal;
    },
    priorityLabel() {
      const labels = {
        'critical': 'CRIT',
        'high': 'HIGH',
        'medium': 'MED',
        'normal': 'NORM',
        'low': 'LOW'
      };
      return labels[this.priority] || 'NORM';
    }
  }
};
</script>
